<template>
  <Appendix
    title="Phụ lục phần mềm"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <slot name="row-details" v-bind="item"></slot>
    </template>
  </Appendix>
</template>
<script>
  import Appendix from './Appendix.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          {
            key: 'timeUsed',
            label: 'Thời gian sử dụng',
            class: 'text-left',
            formatter: (v, k, item) => {
              if (item.appendixPackage.name === 'Vĩnh Viễn') return 'Vĩnh viễn'
              return `${item.appendixPackage.number} ${item.appendixPackage.name}`
            },
          },
          {
            key: 'appendixPackage.price',
            label: 'Đơn giá',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          {
            key: 'appendixPackage.totalPrice',
            label: 'Thành tiền',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
      }
    },
  }
</script>

<style scoped></style>
